/* Coordinate Dawn's drawer with storefront overlays without replacing its focus trap. */
(() => {
  function init() {
    const drawer = document.querySelector('header-drawer');
    const header = drawer?.closest('.section-header');
    const details = drawer?.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!header || !summary || drawer.dataset.novaNavigationReady) return;
    drawer.dataset.novaNavigationReady = 'true';
    const spacer = document.createElement('div');
    spacer.hidden = true;
    spacer.setAttribute('aria-hidden', 'true');
    spacer.dataset.novaHeaderSpacer = '';
    header.insertAdjacentElement('afterend', spacer);
    const inertBefore = new Map();

    function measure() {
      if (details.open) return;
      const rect = header.getBoundingClientRect();
      header.style.setProperty('--nova-menu-top', `${Math.max(0, rect.top)}px`);
      spacer.style.height = `${rect.height}px`;
    }
    function sync() {
      const open = header.classList.contains('menu-open');
      spacer.hidden = !open;
      document.documentElement.toggleAttribute('data-nova-menu-open', open);
      if (open) {
        document.querySelectorAll('main, footer, .nova-discount-tab, shopify-chat').forEach(element => {
          if (!inertBefore.has(element)) inertBefore.set(element, element.inert);
          element.inert = true;
        });
      } else {
        inertBefore.forEach((value, element) => { element.inert = value; });
        inertBefore.clear();
      }
    }
    function resize() {
      // Dawn otherwise keeps the body locked when a tablet drawer becomes a desktop menu.
      if (details.open && getComputedStyle(drawer).display === 'none') {
        drawer.closeMenuDrawer(new Event('resize'), summary);
        summary.setAttribute('aria-expanded', 'false');
      }
    }
    // Dawn's endpoints can include hidden tablet utility links. Supplement its
    // trap only at the currently visible endpoints; retain its submenu handling.
    function containTab(event) {
      if (event.key !== 'Tab' || !details.open) return;
      const visible = Array.from(drawer.querySelectorAll(
        'summary, a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(element => {
        const style = getComputedStyle(element);
        return element.tabIndex >= 0 && element.getClientRects().length &&
          style.visibility === 'visible' && !element.closest('[inert]');
      });
      const first = visible[0];
      const last = visible[visible.length - 1];
      if (!first || !last) return;
      const current = document.activeElement;
      if ((!event.shiftKey && current === last) ||
          (event.shiftKey && (current === first || !drawer.contains(current)))) {
        event.preventDefault();
        event.stopPropagation();
        (event.shiftKey ? last : first).focus();
      }
    }
    drawer.addEventListener('keydown', containTab, true);
    summary.addEventListener('click', measure, true);
    const observer = new MutationObserver(sync);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', resize);
    function unload(event) {
      if (event.target !== header) return;
      if (details.open) drawer.closeMenuDrawer(new Event('unload'), summary);
      observer.disconnect();
      header.classList.remove('menu-open');
      sync();
      spacer.remove();
      window.removeEventListener('resize', resize);
      drawer.removeEventListener('keydown', containTab, true);
      summary.removeEventListener('click', measure, true);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
